module.exports = __webpack_public_path__ + "img/add-white.979dce92.svg";